import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Alert, Button, Snackbar } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SaveIcon from "@mui/icons-material/Save";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahKirimGambar = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noKirimGambar, setNoKirimGambar] = useState("");
  const [tanggalKirimGambar, setTanggalKirimGambar] = useState(new Date());
  const [noRab, setNoRab] = useState("");
  const [tanggalDpRab, setTanggalDpRab] = useState(null);
  const [gambarKe, setGambarKe] = useState("");
  const [keteranganKirimGambar, setKeteranganKirimGambar] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getKirimGambarById();
  }, []);

  const getKirimGambarById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/kirimGambars/${id}`,
      {},
      navigate,
      dispatch
    );
    setNoKirimGambar(response.data.noKirimGambar);
    setTanggalKirimGambar(new Date(response.data.tanggalKirimGambar));
    setNoRab(response.data.rab.noRab);
    setTanggalDpRab(new Date(response.data.rab.tanggalDpRab));
    setGambarKe(response.data.gambarKe);
    setKeteranganKirimGambar(
      response.data.keteranganKirimGambar.toLocaleString("en-US")
    );
    setLoading(false);
  };

  const updateKirimGambar = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() && tanggalKirimGambar !== null) {
      setLoading(true);
      await postRequest(
        `/updateKirimGambar/${id}`,
        {
          tanggalKirimGambar,
          gambarKe,
          keteranganKirimGambar,
        },
        navigate,
        dispatch
      );
      setLoading(false);
      navigate(`/daftarKirimGambar/kirimGambar/${id}`);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Kirim Gambar</h5>
      <hr />
      <Card>
        <Card.Header>Kirim Gambar</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updateKirimGambar}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Kirim Gambar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noKirimGambar}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Kirim Gambar <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={tanggalKirimGambar}
                      customInput={<Form.Control required />}
                      onChange={(date) => setTanggalKirimGambar(date)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control required value={noRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. DP RAB :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      disabled
                      dateFormat="dd/MM/yyyy"
                      selected={tanggalDpRab}
                      customInput={<Form.Control disabled />}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Gambar Ke-<b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      type="number"
                      value={gambarKe}
                      onChange={(e) => setGambarKe(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      style={{ textTransform: "uppercase" }}
                      as="textarea"
                      rows={4}
                      value={keteranganKirimGambar}
                      onChange={(e) => {
                        setKeteranganKirimGambar(e.target.value);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate(`/daftarKirimGambar/kirimGambar/${id}`)}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahKirimGambar;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const colorRed = {
  color: "red",
};
